import React, { useEffect, useState, useContext } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import images from '../../../services/images';
import initTreeView from '../../../services/initTreeView';
import Dropdown from 'react-bootstrap/Dropdown'
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import PaymentsListModal from '../../modals/PaymentsListModal';
import { Accordion, AccordionTab } from 'primereact/accordion';
import StoreInfo from '../../parts/StoreInfo';
import ProfileContext from '../../../services/profileContext';
import { MdHandyman } from "react-icons/md";
import { TbRefresh } from "react-icons/tb";
import CancelItemsFormModal from '../../modals/CancelItemsFormModal';
import { parse } from 'date-fns';

export default function QuotationView (){
    const {
        account
    } = useContext(ProfileContext);
    const default_currency = helpers.getSettingValue(account?.settings, 'default_currency', '₱');
    const tax_enabled = helpers.getSettingValue(account?.settings, 'tax_enabled', 1);
    const discount_enabled = helpers.getSettingValue(account?.settings, 'discount_enabled', 1);
    const single_label = helpers.getSettingValue(account?.settings, 'quotation_single_label', 'Quotation');
    const plural_label = helpers.getSettingValue(account?.settings, 'quotation_plural_label', 'Quotations');
    const heading_label = `Manage ${plural_label}`;
    const sales_order_label = helpers.getSettingValue(account?.settings, 'sales_order_single_label', 'Sales Order');
    const page_title = `${single_label} Details`;
    const main_domain = helpers.getMainDomain()

    const { quotation_id } = useParams();
    const [loading, setLoading] = useState(1);
    //const [page_title, setPageTitle] = useState(`${single_label} Details`);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [record_data, setRecordData] = useState(store.sales_order_data);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    const [payments_modal, setPaymentsModal] = useState(false);
    const [order_table, setOrderTable] = useState([]);

    const [cancel_items_modal, setCancelItemsModal] = useState(false);
    const [cancelled_table, setCancelledTable] = useState([]);
    const navigate = useNavigate();
    
   
    useEffect(() => {
        initTreeView()
        if(quotation_id){
            fetchData()
        }
    }, []);

    useEffect(() => {
        displayTableItems()
    }, [record_items]);

    useEffect(() => {
        displayOrderItems()
        displayCancelledItems()
    }, [record_data]);

    function fetchData(){
        // if(!quotation_id){
        //     return
        // }
        const url = helpers.createUrl(`V1/manage/quotations/${quotation_id}?store_id=${helpers.getStoreID()}`)
        
        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            let items = res;
            items.quotation_date = new Date(res.quotation_date)

            setLoading(0)
            setRecordData(items)
            setRecordItems(items.items)
            setRecordLoaded(1)
        })
        .catch((err) => {
            setLoading(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/quotations/list");
                }
            })
        }); 

    }
    function computeSubTotals(){
        let items = 0;
        let total_amount = 0

        record_items.forEach((data) => {
            const quantity = parseInt(data.quantity ?? '0', 10);
            const price = parseFloat(data.amount ?? '0');
            const discount = parseFloat(data.discount_amount ?? '0');

            const totalPrice = price * quantity
            const netPrice = totalPrice - discount;

            items += quantity;
            total_amount += netPrice
        });

        return helpers.formatCurrencyAmount(total_amount, default_currency);
    }

    function displayTableItems(){
        let items = []
        
        if (record_items.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                return(
                <tr>
                    <td>
                        <div className='mb-0'>{data.product_name}{data.product_variant_name != 'Generic' ? ` (${data.product_variant_name})` : ''}</div>
                        {data.product_description ? <div className='mt-2' style={{whiteSpace: 'pre-line', maxHeight: '150px', overflow: 'auto', fontSize: '12px'}}>{data.product_description}</div> : ''}
                    </td>
                    <td>{data.quantity}{data.unit_name ? <small> {data.unit_name}</small> : ''}</td>
                    {/* <td>
                        <p className='mb-1'>{data.fulfilled_quantity} Fulfilled</p>
                        <p className='mb-1'>{data.returned_quantity} Returned</p>
                        {
                            parseFloat(data.cancelled_quantity) ?  
                            <p className='mb-1 text-danger'>{helpers.normalizeDecimal(data.cancelled_quantity)} Cancelled</p> : ''
                        }
                    </td> */}
                    <td>{helpers.formatCurrencyAmount(data.amount, default_currency)}</td>
                    {parseInt(discount_enabled) ? 
                    <td>
                        {helpers.formatCurrencyAmount(data.discount_amount, default_currency)}<br/>
                        <small>{data.discount_name ? `(${data.discount_name})` : ''}</small>
                    </td> : ''
                    }
                    <td>{helpers.formatCurrencyAmount(data.total_amount, default_currency)}</td>
                </tr>)

            })
        }

        setTableItems(<tbody>{items}</tbody>)
    }

    
    function displayOrderItems(){
        if (record_data?.order && Object.entries(record_data.order).length) {
            let items = []
            const order = record_data.order
            items = <tr>
                        <td>{order.order_date}</td>
                        <td><Link to={`/sales/${order.id}`} target='_blank'>{order.order_no}</Link></td>
                        <td>{helpers.formatCurrencyAmount(order.total_amount, default_currency)}</td>
                        <td>{helpers.displayFulfillmentStatusBadge(order.fulfillment_status_id, order.fulfillment_name)}</td>
                        <td>{helpers.displayOrderStatusBadge(order.order_status_id, order.order_status)}</td>
                        <td width={20}>
                            <div  className='text-center'>
                            <Dropdown as={ButtonGroup} drop="down" className='mr-sm-2' size="sm" >
                                <Dropdown.Toggle variant="outline-dark" id="dropdown-split-basic" />
                                <Dropdown.Menu>
                                    <Dropdown.Item href={`/sales/${order.id}/print`} target='_blank'><i className="fas fa-print mr-2" style={{width: '20px'}} />Print View</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            </div>
                        </td>
                    </tr>

            setOrderTable(<div className="container mb-3">
                <Accordion>
                    <AccordionTab header={`Associated ${sales_order_label}`} className="text-dark">
                        <div className='table-responsive-md mb-0'>
                        <table className="table table-sm mb-0">
                            <thead>
                            <tr>
                                <th>Date</th>
                                <th>Order #</th>
                                <th>Amount</th>
                                <th>Fulfillment</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>{items}</tbody>
                        </table>
                        </div>
                    </AccordionTab>
                </Accordion>
            </div>)
        }
    }

    function displayCancelledItems(){
        if(hasCancelledQuantity(record_items)){
            let tableItems = []
            
            tableItems = Object.entries(record_items).map(([key, data]) => {
                if(!parseFloat(data.cancelled_quantity)) return
                return(
                    <tr>
                        <td>{data.product_name}</td>
                        <td>{data.quantity}</td>
                        <td>{helpers.normalizeDecimal(data.cancelled_quantity)}</td>
                    </tr>
                )

            })

            setCancelledTable(<div className="container mb-3">
                <Accordion>
                    <AccordionTab header={`Cancelled Items`} className="text-dark">
                        <div className='table-responsive-md'>
                        <table className="table table-sm mb-0">
                            <thead>
                            <tr>
                                <th>Item Name</th>
                                <th>Ordered Quantity</th>
                                <th>Cancelled Quantity</th>
                            </tr>
                            </thead>
                            <tbody>{tableItems}</tbody>
                        </table>
                        </div>
                    </AccordionTab>
                </Accordion>
            </div>)
        }
    }

    function triggerAction(data, action = '', quotation_id = '', status = ''){
        if(!action) return;

        console.log('action', action)

        if(action === 'open'){
            updateStatusItem(1)
        }
        else if(action === 'confirm'){
            updateStatusItem(2)
        }
        else if(action === 'single-delete' || action === 'bulk-delete'){
            let ids = [];
            ids.push(data)

            let title = 'Delete Invoice'

            Swal.fire({
                title: title,
                text: 'This action cannot be reversed. All associated records will also be deleted. Do you want to continue?',
                showCancelButton: true,
                showConfirmButton: false,
                closeOnCancel: true,
                showDenyButton: true,
                denyButtonText: 'Yes'
            })
            .then((result) => {
                if (result.isDenied) {
                    deleteItem(ids)
                }
            })
        }

        //updateStatusItem(quotation_id, status)
    }

    function redoCancellation(){
        setLoading(0)
        const url = helpers.createUrl(`V1/manage/order/quotations/redo-cancellation`)

            httpRequest(url, 'POST', {
                postdata: {
                    "id": quotation_id
                },
            }, true)
            .then((res) => {
                // setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function deleteItem(id){
        const url = helpers.createUrl('V1/manage/invoices/delete')
        httpRequest(url, 'POST', {
            postdata: {
                "invoice_ids": id,
                "store_id": helpers.getStoreID()
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function forceFulfillment(id, action = ''){
        const url = helpers.createUrl(`V1/manage/order/quotations/${id}/fulfillment`)
        httpRequest(url, 'POST', {
            postdata: {
                "action": action,
                "store_id": helpers.getStoreID()
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 

    }

    function updateStatusItem(status_id){
        const url = helpers.createUrl('V1/manage/quotations/status')
        httpRequest(url, 'POST', {
            postdata: {
                "quotation_id": quotation_id,
                "store_id": helpers.getStoreID(),
                "status_id": status_id
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK"
                })
            }); 
    }

    function createInvoice(id){
        const url = helpers.createUrl('V1/manage/order/quotations/invoice')
        httpRequest(url, 'POST', {
            postdata: {
                "quotation_id": id,
                "store_id": helpers.getStoreID()
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                })
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 

    }

    function createServiceRequest(id){
        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/create-from-orders`)
        setLoading(1)
        httpRequest(endpoint, 'POST', {
            postdata: {
                "reference_id": id,
                "reference_type": 'quotations-order'
            },
        }, true)
            .then((res) => {
                setLoading(0)

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                    allowOutsideClick: false
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        navigate(`/service-requests/${res?.data?.id}/form`);
                    }
                })
            })
            .catch((err) => {
                setLoading(0)

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function handleCancelItems(e){
        Swal.fire({
            title: "Success",
            text: e.message,
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick: false
        })
        .then((result) => {
            if (result.isConfirmed) {
                window.location.reload();
            }
        })
    }

    function hasCancelledQuantity(items) {
        return items.some(item => parseFloat(item.cancelled_quantity) > 0);
    }

    function isOrderFullyFulfilled(items) {
        const totalQuantity = items.reduce(
            (sum, item) => sum + Number(item.quantity),
            0
        );

        const totalFulfilled = items.reduce(
            (sum, item) => sum + Number(item.fulfilled_quantity),
            0
        );

        return totalQuantity === totalFulfilled;
    }

    return (
        <>
        <PaymentsListModal show_modal={payments_modal} id={quotation_id} close_modal={setPaymentsModal} />

        <CancelItemsFormModal 
            origin='sales-order'
            reference_id={quotation_id}
            is_show={cancel_items_modal} 
            setShow={setCancelItemsModal} 
            handleSave={handleCancelItems} 
        />

        <Layout page_title={page_title} menu="manage-quotations" breadcrumbs={true} parent_link='/quotations/list' parent_text={heading_label}>
                <div className="content" style={{position: 'relative'}}>
                    <Loader isLoading={loading}/>

                    <div className="container-fluid">
                            <div className="row mb-2">
                                <div quotation_id="so-customer-section" className="col-lg-12">
                                    {record_loaded ?
                                    <div className='border rounded p-3 mb-3 d-flex justify-content-between align-items-center'>

                                        <h5 className='mb-0 mb-md-0 d-flex'>{record_data.quotation_no}</h5>

                                        <div className='d-sm-flexs flex-column flex-sm-row d-nones'>
                                            <Dropdown as={ButtonGroup} drop="down" className='mr-2' >
                                                <Dropdown.Toggle variant="outline-dark" id="dropdown-split-basic" />
                                                <Dropdown.Menu>
                                                    {
                                                    parseInt(record_data.quotation_status_id) === 2 ? 
                                                    <Dropdown.Item onClick={(e) => triggerAction(quotation_id, 'approved', 3)}><i className="fas fa-check-circle text-success mr-2" style={{width: '20px'}} />Approve Quotation</Dropdown.Item> : ''
                                                    }

                                                    {
                                                        parseInt(record_data.quotation_status_id) === 1 || parseInt(record_data.quotation_status_id) === 2 ?
                                                        <Dropdown.Item as={Link} to={`/quotations/${quotation_id}/edit`}><i className="fas fa-pencil-alt mr-2" style={{width: '20px'}} />Edit</Dropdown.Item>:''
                                                    }

                                                    {/* <Dropdown.Item href={`/quotations/${quotation_id}/print`} target='_blank'><i className="fas fa-print mr-2" style={{width: '20px'}} />Print View</Dropdown.Item> */}

                                                    
                                                    {
                                                        main_domain === "polar-air.com" ? 
                                                        <Dropdown.Item href={`/quotations/${quotation_id}/print-polarair`} target='_blank'><i className="fas fa-print mr-2" style={{width: '20px'}} />Print View</Dropdown.Item>
                                                        : 
                                                        <Dropdown.Item href={`/quotations/${quotation_id}/print-polarair`} target='_blank'><i className="fas fa-print mr-2" style={{width: '20px'}} />Print View</Dropdown.Item>
                                                    }
                                                </Dropdown.Menu>
                                            </Dropdown>

                                            <Link className='btn btn-dark' to="/quotations/list">Cancel</Link>  
                                        </div>
                                    </div> : ''}
                                </div>
                            </div>
                    </div>

                    {
                        order_table
                    }

                    {
                        cancelled_table
                    }

                            
                    <div className="container">
                        {
                            record_loaded ?
                            <div className="invoice p-4 mb-3 rounded">
                                <div className="d-flex justify-content-between mb-3">
                                    <StoreInfo store={record_data.store_info} />

                                    <div className='text-right'>
                                        <h2><strong>{helpers.capitalizeString(single_label)}</strong></h2>
                                        <h5>{helpers.displayQuotationStatusBadge(record_data.quotation_status_id, record_data.status_name)}</h5>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-4 mb-3">
                                        <h5 className='mb-0'><b>Bill To:</b></h5>
                                        <div>
                                            <p className='mb-0'><b>{record_data.customer_name}</b></p>
                                            <p className='mb-0'>{record_data.billing_address}</p>
                                            <p className='mb-0'>{record_data.billing_phone}</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <h5 className='mb-0'><b>Ship To:</b></h5>
                                        <div>
                                            <p className='mb-0'><b>{record_data.shipping_contact_name}</b></p>
                                            <p className='mb-0'>{record_data.shipping_address}</p>
                                            <p className='mb-0'>{record_data.shipping_phone}</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 text-lg-right mb-2">
                                        <table className='table table-borderless table-sm'>
                                            <tbody>
                                                <tr>
                                                    <td className='py-0'><b>Quote #:</b></td>
                                                    <td className='py-0'>{record_data.quotation_no ? record_data.quotation_no : '---'}</td>
                                                </tr>
                                                <tr>
                                                    <td className='py-0'><b>Date:</b></td>
                                                    <td className='py-0'>{helpers.formatDate(record_data.quotation_date)}</td>
                                                </tr>
                                                <tr>
                                                    <td className='py-0'><b>Version</b></td>
                                                    <td className='py-0'>{record_data.quote_version ? record_data.quote_version : '---'}</td>
                                                </tr>
                                                <tr>
                                                    <td className='py-0'><b>Payment&nbsp;Terms:</b></td>
                                                    <td className='py-0'>{record_data.payment_term ? record_data.payment_term : '---'}</td>
                                                </tr>
                                                <tr>
                                                    <td className='py-0'><b>Sales&nbsp;Person:</b></td>
                                                    <td className='py-0'>{record_data.sales_person ? record_data.sales_person : '---'}</td>
                                                </tr>
                                                {
                                                    record_data.quotation_status_id == 4
                                                    ?
                                                    <>
                                                    <tr>
                                                        <td className='py-0'><b>Cancellation&nbsp;Reason:</b></td>
                                                        <td className='py-0'>{record_data.reason}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='py-0'><b>Remarks:</b></td>
                                                        <td className='py-0 text-sm'>{record_data.cancel_remarks ? record_data.cancel_remarks : 'N/A'}</td>
                                                    </tr>
                                                    </>
                                                    : ''
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className='table-responsive'>
                                    <table className='table table-striped table-sm border-bottom'>
                                        <thead>
                                            <tr>
                                                <th>Item & Description</th>
                                                <th>Ordered</th>
                                                {/* <th>Status</th> */}
                                                <th>Price</th>
                                                {parseInt(discount_enabled) ? <th>Discount</th> : ''}
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        {
                                            table_items
                                        }
                                    </table>
                                </div>

                                <div className='row'>
                                    <div className="col-lg-7 d-flex align-items-center">{record_data.customer_notes ? <p className='pt-1 pt-lg-4'>{record_data.customer_notes}</p>:''}</div>
                                    <div className="col-lg-5 mb-0 border p-2">
                                        <table className='table table-sm table-borderless mb-0'>
                                            <tbody>
                                                <tr>
                                                    <td className='border-top-0'><b>Sub Total</b></td>
                                                    <td className='border-top-0'>{computeSubTotals()}</td>
                                                </tr>
                                                {parseInt(discount_enabled) ?
                                                <tr>
                                                    <td><b>Total Discount</b></td>
                                                    <td>{parseFloat(record_data.total_discount) > 0 ? helpers.formatCurrencyAmount(record_data.total_discount, default_currency) : helpers.formatCurrencyAmount(0, default_currency)}</td>
                                                </tr> : ''
                                                }
                                                <tr>
                                                    <td><b>Shipping Fee</b></td>
                                                    <td>{helpers.formatCurrencyAmount(record_data.shipping_fee, default_currency)}</td>
                                                </tr>
                                                {parseInt(tax_enabled) ?
                                                <tr>
                                                    <td><b>Total Tax</b></td>
                                                    <td>{helpers.formatCurrencyAmount(record_data.total_tax, default_currency)}</td>
                                                </tr> : ''
                                                }
                                                <tr className='bg-dark'>
                                                    <td><b>Total</b></td>
                                                    <td>{helpers.formatCurrencyAmount(record_data.total_amount, default_currency)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            : 
                            <div className="invoice p-5 mb-3">
                                <h4>&nbsp;</h4>
                            </div>
                        }
                    </div>
                </div>
        </Layout>
        </>
    )
}